import { Pipe, type PipeTransform } from "@angular/core";
import { getCompactedDMC } from "@orion2/utils/functions.utils";

@Pipe({
  name: "compactedDmc",
  standalone: true
})
/**
 * Allows you to transform a DMC full into a compacted DMC.
 * Exemple H160: DMC-H160-ORION-B-67-33-0105-00A-520A-B_sx-US -> H160-B-67-33-0105-00A-520A-B
 * Exemple Tiger: DMC-JP-ALL-A001-29-11-0000-00D-412A-A_fr-FR -> JP-A001-29-11-0000-00D-412A-A
 */
export class CompactedDmcPipe implements PipeTransform {
  transform(dmcFull: string): string {
    return getCompactedDMC(dmcFull);
  }
}
